import React, { ReactNode } from "react";

export interface NavLeftProps {
	children?: ReactNode;
}

const NavRight: React.FC<NavLeftProps> = ({ children }) => {
	return (
		<ul className="nav navbar-nav border-0 navbar-right mainNav">
			{children}
		</ul>
	);
};

export default NavRight;
